import { render } from "./InfoRealTimePage.vue?vue&type=template&id=b0b5e218&ts=true"
import script from "./InfoRealTimePage.vue?vue&type=script&lang=ts"
export * from "./InfoRealTimePage.vue?vue&type=script&lang=ts"

import "./InfoRealTimePage.vue?vue&type=style&index=0&id=b0b5e218&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/BV_HV/Dashboard_HV/Dashboard_FE_HV/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__